/**
 * Combined UFO experiences for the AI widget
 * Aggregates experiences from both CSM and JSM contexts
 */

import type { ConcurrentExperience } from '@atlaskit/ufo/concurrent-experience';

import { CSM_AI_WIDGET_STORE_UFO_EXPERIENCES } from './store-csm-ufo/ufoExperiences';
import { JSM_AI_WIDGET_STORE_UFO_EXPERIENCES } from './store-jsm-ufo/ufoExperiences';

/**
 * Combined experiences object that includes both CSM and JSM live chat experiences
 */
export const AI_WIDGET_STORE_UFO_EXPERIENCES: {
	readonly INITIALIZE_LIVE_CHAT: ConcurrentExperience;
	readonly EXIT_LIVE_CHAT: ConcurrentExperience;
	readonly INITIALIZE_TWILIO_LIVE_CHAT: ConcurrentExperience;
	readonly END_TWILIO_LIVE_CHAT: ConcurrentExperience;
	readonly HYDRATE_TWILIO_LIVE_CHAT: ConcurrentExperience;
	readonly SEND_TWILIO_LIVE_CHAT_MESSAGE: ConcurrentExperience;
	readonly SEND_MESSAGE: ConcurrentExperience;
} = {
	...CSM_AI_WIDGET_STORE_UFO_EXPERIENCES,
	...JSM_AI_WIDGET_STORE_UFO_EXPERIENCES,
} as const;
